/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Stock_Out_Lot_PositionInputs */

const vi_stock_out_lot_position = /** @type {(inputs: Stock_Out_Lot_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vị trí ${i?.code}`)
};

/**

* @param {Stock_Out_Lot_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_lot_position = /** @type {((inputs: Stock_Out_Lot_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Lot_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_lot_position(inputs)
});